import React from "react";
import SovosBox from "mosaic-react/sovos-box";
import SovosLink from "mosaic-react/sovos-link";
import { SovosAboutThisProductDialog } from "mosaic-react-platform";

export const AboutThisDialog = (props) => {
    const {
        isOpen,
        setIsAboutThisDialogOpen,
        productName,
        localesByAppTheme,
        i18n,
        version,
        learnMoreUrl,
        sovosLinkURL,
        privacyPolicyUrl,
        termsAndConditionsUrl,
    } = props || {};
    const handleAboutThisDialogClose = () => {
        setIsAboutThisDialogOpen(false);
    };
    const availbableLanguages = (localesByAppTheme || [{}])
        .reduce((acc, { name }) => {
            acc.push(i18n`${name}`);
            return acc;
        }, [])
        .join(", ");

    return (
        <SovosAboutThisProductDialog
            description={
                <SovosBox display="flex" flexDirection="column" gap={2}>
                    <div>
                        {i18n`This application is available in:` + ` ${availbableLanguages}.`}
                        <SovosLink href={sovosLinkURL}>
                            {i18n`Change your language preferences.`}
                        </SovosLink>
                    </div>
                    <div>
                        {/*To fill date on text based on calendar year*/}
                        {i18n`© ${new Date().getFullYear().toString()} Sovos Compliance, LLC. All rights reserved. ${productName} is a trademark of Sovos Compliance, LLC. Registered in the US and other countries.`}
                    </div>
                </SovosBox>
            }
            learnMoreUrl={learnMoreUrl}
            open={isOpen}
            onClose={handleAboutThisDialogClose}
            privacyPolicyUrl={privacyPolicyUrl}
            termsAndConditionsUrl={termsAndConditionsUrl}
            version={version}
        />
    );
};
